import axiosClient from '@services/api/axiosClient';

/**
 * POST /v1/auth/login
 * Body: { email, password }
 * Success data: { token, userData }
 */
export const loginRequest = (credentials, config = {}) =>
  axiosClient.post('auth/login', credentials, config);
